// extracted by mini-css-extract-plugin
export default {"CardsContainer":"CaseStudyPage_CardsContainer__qI0lP","InnerContainer":"CaseStudyPage_InnerContainer__iJJNH"};